import Button from 'v2/components/Button';
import IconFrame from 'v2/components/IconFrame';
import CardActionLinkText from 'v2/components/text/CardActionLinkText';

import ArrowRightIcon from 'components/icons/ArrowRightIcon';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const CardActionLinkButton: FunctionComponent<Props> = ({
    className = '',
    onClick,
    testId = TEST_ID,
    text
}) => (
    <Button
        className={`${styles.cardActionLinkButton} ${className}`}
        onClick={onClick}
        testId={testId}
    >
        <CardActionLinkText text={text} />

        <IconFrame className={styles.icon}>
            <ArrowRightIcon />
        </IconFrame>
    </Button>
);

export default CardActionLinkButton;
